import '../components/quantity-selector.js';
import Modal from '../components/modal.js';
import EVENT from '../enums/event.js';
import renderSectionFromResponse from '../utils/render-section-from-response.js';
import updateCartCount from '../utils/update-cart-count.js';
import onDocumentReady from '../utils/on-document-ready.js';
import dispatchEvent from '../utils/dispatch-event.js';

class CartModal extends HTMLElement {
  constructor() {
    super();

    onDocumentReady(() => {
      this.$cartModal = document.querySelector('[data-modal="cart"]');

      if (!this.$cartModal) {
        return;
      }

      this.$header = document.querySelector('[data-header]');
      this.$modal = document.querySelector('[data-modal="cart"]');
      this.$trigger = document.querySelector('[data-modal-toggle="cart"]');

      this.breakpoint = window.matchMedia('(min-width:768px)');
      this.modal = new Modal(this.$modal);
      this.sectionId = 'cart-modal';

      this.updatePosition();
      this.registerEventListeners();
    });
  }

  // Set the modal position
  updatePosition() {
    // Check if there is a trigger and on desktop...
    if (this.$trigger && this.breakpoint.matches) {
      // If so, position relative to the trigger.
      const { right } = this.$trigger.getBoundingClientRect();

      this.$modal.style.right = `${document.body.clientWidth - right}px`;
      this.$modal.style.top = `${this.$header.offsetHeight + 28}px`;
    } else {
      // If not, position just below the header and full width.
      this.$modal.style.right = '0px';
      this.$modal.style.top = `${this.$header.offsetHeight}px`;
    }
  }

  registerEventListeners() {
    document.addEventListener(EVENT.CART.UPDATE, event => {
      fetch(`${window.Shopify.routes.root}cart?sections=${this.sectionId}`)
        .then(response => response.json())
        .then(response => {
          // Update the modal heading
          renderSectionFromResponse(
            '[data-cart-modal-heading]',
            this.sectionId,
            response
          );

          // Update the modal line items
          renderSectionFromResponse(
            '[data-cart-modal-line-items]',
            this.sectionId,
            response
          );

          updateCartCount();

          if (event.detail?.action === 'open-cart-modal') {
            const $cartTrigger = document.querySelector(
              '[data-modal-toggle="cart"]'
            );
            dispatchEvent(EVENT.MODAL.OPEN, $cartTrigger, {
              detail: {
                modal: 'cart',
              },
            });
          }
        });
    });

    window.addEventListener('resize', () => {
      this.updatePosition();
    });

    window.addEventListener(
      'scroll',
      () => {
        // Allow time for the header to resize before updating the position.
        setTimeout(() => {
          this.updatePosition();
        }, 300);
      },
      {
        passive: true,
      }
    );
  }
}

customElements.define('cart-modal', CartModal);
